var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYeetchiv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3663_318328)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 24,
    fill: "#5B5FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3043 20.4824C6.4056 26.2469 -4.73558 52.5073 -8.49616 68.1918C-15.6252 97.926 -15.2421 160.146 39.1572 168.906C132.224 183.892 167.185 168.081 175.394 161.562C180.834 157.241 209.949 133.097 203.156 83.1091C197.002 37.82 187.961 28.6631 158.98 22.5136C143.819 19.2968 93.9276 13.2768 45.3043 20.4824Z",
    fill: "url(#paint0_linear_3663_318328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3768 42.6736C15.4785 42.4081 10.0457 77.5081 11.5666 95.0912C11.6434 131.597 31.6626 143.626 38.4907 145.435C45.3189 147.243 135.881 149.976 146.66 147.417C157.44 144.859 186.179 141.244 184.021 91.9817C181.862 42.7199 156.488 45.5773 143.397 43.3274C130.307 41.0775 91.7496 43.0055 49.3768 42.6736Z",
    fill: "#23254E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.49 74.1804C134.694 71.2813 142.871 53.4715 146.746 45.2469C186.99 44.7726 183.129 90.1895 181.643 111.274C176.431 104.175 162.591 90.7282 151.834 89.9701C147.774 77.4342 139.972 75.8911 134.49 74.1804Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3696 42.4969C15.5818 45.3327 10.0289 77.3945 11.5481 95.0072C11.6209 131.575 31.6417 143.622 38.4707 145.433C45.2997 147.244 135.875 149.971 146.656 147.407C157.437 144.843 186.182 141.218 184.028 91.8736C181.874 42.5288 156.655 44.0751 143.404 43.1416L143.396 43.141C128.973 42.1249 88.1064 39.2457 49.3696 42.4969Z",
    stroke: "url(#paint1_linear_3663_318328)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3663_318328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.458 91.5849C47.914 88.075 62.8019 83.1379 78.7051 91.4691C66.0439 97.5198 49.2648 94.0675 42.458 91.5849Z",
    fill: "url(#paint2_linear_3663_318328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.411 74.821C120.693 75.9349 116.004 85.8636 114.999 90.6887C113.855 94.2802 117.341 95.1932 120.533 97.0876C123.724 98.9821 125.492 92.7633 132.533 91.9245C139.574 91.0857 141.374 98.5566 147.446 97.315C152.304 96.3217 151.939 90.1765 151.149 87.228C149.036 82.6281 142.128 73.707 131.411 74.821Z",
    fill: "url(#paint3_linear_3663_318328)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3663_318328",
    x: 34.458,
    y: 68.7256,
    width: 125.162,
    height: 38.729,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3663_318328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3663_318328",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3663_318328",
    x1: 94.9733,
    y1: 114.481,
    x2: 90.7425,
    y2: 174.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3663_318328",
    x1: 24.9711,
    y1: 53.1737,
    x2: 167.91,
    y2: 128.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322115,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#898989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3663_318328",
    x1: 98.3928,
    y1: 72.2277,
    x2: 96.617,
    y2: 97.4232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86FFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8692FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3663_318328",
    x1: 98.3928,
    y1: 72.2277,
    x2: 96.617,
    y2: 97.4232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86FFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8692FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3663_318328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYeetchiv2);
export default __webpack_public_path__ + "static/media/Yeetchi v2.3975da47e7bf2c9b81504d22001a2327.svg";
export { ForwardRef as ReactComponent };